import { useCallback, useEffect, useState } from 'react'

type Props = NotificationOptions & {
  title: string
  closeAfter?: number
  onClick?: () => void
}

export function useNotifyBrowser() {
  const [missedCount, setMissedCount] = useState(0)

  useEffect(() => {
    const strippedTitle = document.title.replace(/^\([0-9]+\)\s/, '')

    if (missedCount === 0) {
      document.title = strippedTitle
    } else {
      document.title = `(${missedCount}) ${strippedTitle}`
    }
  }, [missedCount])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setMissedCount(0)
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [])

  return useCallback(
    (props: Props) => {
      if (Notification.permission !== 'granted') return

      const { title, closeAfter, ...options } = props

      const notification = new Notification(title, {
        icon: '/app/favicon.ico',
        ...options
      })

      if (document.visibilityState === 'hidden') {
        setMissedCount(c => c + 1)
      }

      if (closeAfter) setTimeout(() => notification.close(), closeAfter)

      notification.onclick = () => {
        window.focus()
        notification.close()
        props.onClick?.()
      }

      return notification
    },
    [setMissedCount]
  )
}
